import { useMemo } from "react";

import { skipToken } from "@reduxjs/toolkit/query";

import { useGetAvailablePaymentMethodsQuery, useGetCustomerCartIdQuery } from "@jti/store/slices/magentoApiSlice";
import { useGetPaymentMethodsQuery } from "@jti/store/slices/paymentApiSlice";

import { useCustomerOrder } from "@checkout-v2/shared/hooks/useCustomerOrder";

export const useAvailablePaymentMethodsForOrder = () => {
  const { data: cartIdData } = useGetCustomerCartIdQuery();
  const { data: orderData, isLoading: isLoadingOrder } = useCustomerOrder();

  const cartId = cartIdData?.customerCart?.id;
  const orderItems = orderData?.items;
  const skus = useMemo(() => (orderItems ?? []).map((item) => item.sku), [orderItems]);
  const magentoQueryState = useGetAvailablePaymentMethodsQuery(cartId ?? skipToken);
  const evoQueryState = useGetPaymentMethodsQuery({ skus }, { skip: isLoadingOrder || !skus.length });

  const { data: evoMethods, isLoading: isLoadingEvo, isError: isEvoError, error: evoError } = evoQueryState;

  const isLoading = isLoadingOrder || isLoadingEvo || magentoQueryState.isLoading;

  return {
    evoMethods,
    magentoMethods: magentoQueryState.data,
    isLoading,
    isError: isEvoError || magentoQueryState.isError,
    error: evoError || magentoQueryState.error,
    evoQueryState,
    magentoQueryState,
  };
};
